import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { DatenauswertungCO2Fussabdruck } from './DatenauswertungCO2Fussabdruck';
import { DatenauswertungCO2FussabdruckDetails } from './DatenauswertungCO2FussabdruckDetails';
import { DatenauswertungCO2THGStandorte } from './DatenauswertungCO2THGStandorte';
import { DatenauswertungCO2THGSubscopes } from './DatenauswertungCO2THGSubscopes';
import { DatenauswertungThgBericht } from './DatenauswertungThgBericht';
import { getStandorte } from '../../helpers/getStandorte';
import { getVeranstaltungen } from '../../helpers/getVeranstaltungen';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import { getDefaultHelpIcon, getDefaultHelpIconDatei } from '../../helpers/getDefaultHelpIcon';
import { Features } from '../../control/features';
import { hasFeature } from '../../control/hasFeature';

interface DatenauswertungCO2TabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortTid: number;
    standortName: string;
    routing: any;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
}

interface DatenauswertungCO2TabsState {
    tabIndex: number;
}

export class DatenauswertungCO2Tabs extends React.Component<DatenauswertungCO2TabsProps, DatenauswertungCO2TabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDatenauswertungCO2') || 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private devFeaturesMap: any = config.devFeaturesMap || {};

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDatenauswertungCO2', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const enableATA = hasFeature(Features.CO2_AUSWERTUNG_ANTEIL_STANDORTE, this.apiService.getBereichKey());
        const enabledStandorte: boolean = !this.props.standortTid && enableATA;
        // const enabledSubscopes: boolean = enableATA;
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        const disabledThgBericht: boolean = !isCfm;
        const showThgHinweis: boolean = !!this.props.standortTid
            && ((getStandorte(this.props.data) || []).length + (getVeranstaltungen(this.props.data) || []).length) > 1;

        const tabRoutings: any[] = [
            { path: RoutingIDs.ROUTE_CO2_FUSS_GESAMT },
            { path: RoutingIDs.ROUTE_CO2_FUSS_DETAILS },
            { path: RoutingIDs.ROUTE_CO2_FUSS_ANTEIL_STANDORTE },
            { path: RoutingIDs.ROUTE_CO2_FUSS_THG_BERICHT }
        ];
        return (
            <Tabs
                className='tabs-co2'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab>{isCfm ? 'Jahresauswertung' : 'Alle Jahre'}</Tab>
                    <Tab>{isCfm ? 'Alle Jahre' : 'Jahresauswertung'}</Tab>
                    <Tab disabled={!enabledStandorte}>Anteil Standorte</Tab>
                    {/* <Tab disabled={!enabledSubscopes}>Anteil Standorte - Subscopes</Tab> */}
                    <Tab disabled={disabledThgBericht}>THG-Bericht</Tab>
                </TabList>
                <TabPanel>
                    {isCfm ? this.renderDatenauswertungCO2FussabdruckDetails() : this.renderDatenauswertungCO2Fussabdruck()}
                </TabPanel>
                <TabPanel>
                    {isCfm ? this.renderDatenauswertungCO2Fussabdruck() : this.renderDatenauswertungCO2FussabdruckDetails()}
                </TabPanel>
                <TabPanel>
                    {enabledStandorte &&
                         <DatenauswertungCO2THGStandorte
                            data={this.props.data}
                            routing={this.props.routing}
                            onRoutingChange={this.props.onRoutingChange}
                            jahrFirst={this.props.jahrFirst}
                            jahrLast={this.props.jahrLast}
                        />
                    }
                </TabPanel>
                {/* <TabPanel>
                    {enabledSubscopes && <div>In Entwicklung ...</div>}
                </TabPanel> */}
                <TabPanel>
                    {!disabledThgBericht && !showThgHinweis && getDefaultHelpIcon('datenauswertung_thg_bericht', 'THG-Bericht - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    {!disabledThgBericht &&
                        showThgHinweis
                        ? <div style={{ padding: '0 20px 20px' }}>
                            {renderText('Treibhausgasbericht - Standorthinweis', this.props.data)}
                        </div>
                        : <DatenauswertungThgBericht
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    renderDatenauswertungCO2Fussabdruck(): JSX.Element {
        return <>
            {getDefaultHelpIcon('datenauswertung_co2', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
            <DatenauswertungCO2Fussabdruck
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={this.props.standortTid}
                standortName={this.props.standortName}
                jahrFirst={this.props.jahrFirst}
                jahrLast={this.props.jahrLast}
            />
        </>;
    }

    renderDatenauswertungCO2FussabdruckDetails(): JSX.Element {
        return <>
            {getDefaultHelpIcon('datenauswertung_co2_details', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
            <DatenauswertungCO2FussabdruckDetails
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={this.props.standortTid}
                standortName={this.props.standortName}
            />
        </>;
    }
}
